// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "PricingSection-module--wrapper--Z2fNs";
export var paymentsMethodsInfoWrapper = "PricingSection-module--paymentsMethodsInfoWrapper--uvF-E";
export var paymentsMethodsList = "PricingSection-module--paymentsMethodsList--tZn2O";
export var paymentsMethodsAdditionalDescription = "PricingSection-module--paymentsMethodsAdditionalDescription--3WhSd";
export var ratesListWrapper = "PricingSection-module--ratesListWrapper--RzcXU";
export var ratesNotFoundText = "PricingSection-module--ratesNotFoundText--XvS6Y";